// import { Box } from "@mui/material";
// import React from "react";
// import SkeletonLoader from "../../../../components/Loaders/SkeletonLoader";

// const CampaignStepSkeleton = () => {
//   const steps = [{}, {}, {}, {}, {}];

//   return (
//     <Box>
//       {steps.map((step, index) => {
//         return (
//           <Box>
//             <SkeletonLoader
//               variant="rounded"
//               skeletonHeight={60}
//               skeletonWidth={100}
//             />
//           </Box>
//         );
//       })}
//     </Box>
//   );
// };

// export default CampaignStepSkeleton;

import { Box } from "@mui/material";
import React from "react";
import SkeletonLoader from "../../../../components/Loaders/SkeletonLoader";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
  },
  stepBox: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
    padding: "1rem",
  },
  separator: {
    height: "1rem",
    borderLeft: "1px solid #dbdbdb",
    margin: "0 1rem",
    marginLeft: "2.313rem",
  },
};

const CampaignStepSkeleton = ({ count = 3 }) => {
  return (
    <Box style={styles.container}>
      {Array.from({ length: count }).map((_, index) => (
        <React.Fragment key={index}>
          <Box style={styles.stepBox}>
            <SkeletonLoader
              variant="circular"
              skeletonWidth={24}
              skeletonHeight={24}
            />
            <SkeletonLoader
              variant="text"
              skeletonWidth={80}
              skeletonHeight={20}
            />
          </Box>
          {index < count - 1 && <Box style={styles.separator} />}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default CampaignStepSkeleton;
